import { useEffect, useState } from 'react';
import { addEvent, removeEvent } from 'ava-util/dist/dom-event';

export interface Options {
    onEnter?: () => void;
    onLeave?: () => void;
    onChange?: (isHovering: boolean) => void;
}

const useHover = (target: HTMLElement | undefined, options?: Options) => {
    const { onEnter, onLeave, onChange } = options || {};

    const [state, setState] = useState<boolean>(false);

    const mouseEnterHandle = () => {
        onEnter?.();
        onChange?.(true);
        setState(true)
    }

    const mouseLeaveHandle = () => {
        onLeave?.();
        onChange?.(false);
        setState(false)
    }

    useEffect(() => {
        if (!!target) {
            removeEvent(target, 'mouseenter', mouseEnterHandle);
            removeEvent(target, 'mouseleave', mouseLeaveHandle);

            addEvent(target, 'mouseenter', mouseEnterHandle);
            addEvent(target, 'mouseleave', mouseLeaveHandle);
        }
        return () => {
            if (!!target) {
                removeEvent(target, 'mouseenter', mouseEnterHandle);
                removeEvent(target, 'mouseleave', mouseLeaveHandle);
            }
        }
    }, [target])

    return state;
};

export default useHover